<template>
  <div class="room dehumidifier-room" v-loading="loadingData">
    <div class="dehumidifier-main">
      <div class="main-column-multi-line">
        <div class="column-line-full">
          <SwitchStatusTitle class="switch-item-title" :title="columnTitleTop1" :bold="true" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop11" :series="switchDataTop11" />
        </div>
      </div>

      <div class="main-column-multi-line">
        <div class="column-line-full">
          <SwitchStatusTitle class="switch-item-title" :title="columnTitleTop2" :bold="true" />
          <SwitchStatus class="switch-item" :title="switchTitleTop23" :series="switchDataTop23" />
          <SwitchStatus class="switch-item" :title="switchTitleTop25" :series="switchDataTop25" />
          <SwitchStatus class="switch-item" :title="switchTitleTop26" :series="switchDataTop26" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop24" :series="switchDataTop24" />
          <SwitchStatus class="switch-item" :title="switchTitleTop28" :series="switchDataTop28" />
          <SwitchStatus class="switch-item" :title="switchTitleTop27" :series="switchDataTop27" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop21" :series="switchDataTop21" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop22" :series="switchDataTop22" />
        </div>
      </div>

      <div class="main-column-multi-line">
        <div class="column-line-full">
          <SwitchStatusTitle class="switch-item-title" :title="columnTitleTop3" :bold="true" />
          <SwitchStatus class="switch-item" :title="switchTitleTop33" :series="switchDataTop33" />
          <SwitchStatus class="switch-item" :title="switchTitleTop35" :series="switchDataTop35" />
          <SwitchStatus class="switch-item" :title="switchTitleTop36" :series="switchDataTop36" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop34" :series="switchDataTop34" />
          <SwitchStatus class="switch-item" :title="switchTitleTop38" :series="switchDataTop38" />
          <SwitchStatus class="switch-item" :title="switchTitleTop37" :series="switchDataTop37" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop31" :series="switchDataTop31" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop32" :series="switchDataTop32" />
        </div>
      </div>

      <div class="main-column-multi-line">
        <div class="column-line-full">
          <SwitchStatusTitle class="switch-item-title" :title="columnTitleTop4" :bold="true" />
          <SwitchStatusValue class="switch-item" :title="switchTitleTop41" :series="switchDataTop41" />
        </div>
      </div>
    </div>

    <RefreshBlock @refreshData="refreshData"></RefreshBlock>
  </div>
</template>

<script>
import configJson from "./config/station_anchor_wincc.json";

export default {
  name: "tower",
  data() {
    return {
      timer: null,
      loading: false,
      loadingData: false,
      stationIdList: "",
      stationName: "",
      stationIndex: "",
      dataSource: "",
      stationVentNameFix: "",
      sideName: "",
      stationTypeName: "",

      outputName1: "",
      outputName2: "",
      outputName3: "",
      outputName4: "",
      outputName5: "",
      outputName6: "",

      exitGasClampListDict: {
        "1出口": ["A1", "A2"],
      },

      switchDataTop11: null,

      switchDataTop21: null,
      switchDataTop22: null,
      switchDataTop23: null,
      switchDataTop24: null,
      switchDataTop25: null,
      switchDataTop26: null,
      switchDataTop27: null,
      switchDataTop28: null,

      switchDataTop31: null,
      switchDataTop32: null,
      switchDataTop33: null,
      switchDataTop34: null,
      switchDataTop35: null,
      switchDataTop36: null,
      switchDataTop37: null,
      switchDataTop38: null,

      switchDataTop41: null,

      deviceList: [],
    };
  },
  computed: {
    columnTitleTop1: function () {
      return this.sideName + "侧上游锚室温湿度(" + this.dataSource + ")";
    },
    columnTitleTop2: function () {
      return this.sideName + "侧上游锚室除湿机(" + this.dataSource + ")";
    },
    columnTitleTop3: function () {
      return this.sideName + "侧下游锚室除湿机(" + this.dataSource + ")";
    },
    columnTitleTop4: function () {
      return this.sideName + "侧下游锚室温湿度(" + this.dataSource + ")";
    },

    switchTitleTop11: function () {
      return "上游锚室";
    },

    switchTitleTop21: function () {
      return "一级启停设定";
    },
    switchTitleTop22: function () {
      return "二级启停设定";
    },
    switchTitleTop23: function () {
      return "上游除湿机";
    },
    switchTitleTop24: function () {
      return "上游除湿机";
    },
    switchTitleTop25: function () {
      return "一级除湿";
    },
    switchTitleTop26: function () {
      return "二级除湿";
    },
    switchTitleTop27: function () {
      return "过滤器";
    },
    switchTitleTop28: function () {
      return "上游风机";
    },

    switchTitleTop31: function () {
      return "一级启停设定";
    },
    switchTitleTop32: function () {
      return "二级启停设定";
    },
    switchTitleTop33: function () {
      return "下游除湿机";
    },
    switchTitleTop34: function () {
      return "下游除湿机";
    },
    switchTitleTop35: function () {
      return "一级除湿";
    },
    switchTitleTop36: function () {
      return "二级除湿";
    },
    switchTitleTop37: function () {
      return "过滤器";
    },
    switchTitleTop38: function () {
      return "下游风机";
    },

    switchTitleTop41: function () {
      return "下游锚室";
    },
  },
  created() {
    this.readConfig();
  },
  mounted() {
    this.getData();
    this.timer = setInterval(() => {
      this.getData();
    }, this.REFRESH_SECOND);
  },
  watch: {
    /**
     * 监听路由变化
     * @param {Object} route # 当前路由信息
     */
    $route(route) {
      this.resetData();
      this.readConfig();
      this.loadingData = true;
      this.getData();
    },
  },
  methods: {
    resetData() {
      this.warningFlagLeft = "";
      this.warningFlagRight = "";
      this.warningFlag1 = "";
      this.warningFlag2 = "";
      this.warningFlag3 = "";
      this.warningFlag4 = "";
    },
    refreshData() {
      this.loadingData = true;
      this.getData();
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.getData();
      }, this.REFRESH_SECOND);
    },
    assembleExitGasClamp(exitName) {
      let gasClampName = "";
      if (exitName && this.exitGasClampListDict[exitName]) {
        let gasClampList = this.exitGasClampListDict[exitName];
        for (let gasClamp of gasClampList) {
          if (gasClampName !== "") {
            gasClampName += ", ";
          }
          gasClampName += gasClamp;
        }
      }

      let result = exitName + "连接气夹: " + gasClampName;
      return result;
    },
    readConfig() {
      const routerPath = this.$route.fullPath.split("/");
      const routerName = routerPath[3].toLowerCase();

      this.deviceList = configJson[routerName].deviceList;
      this.stationName = configJson[routerName].stationName;
      this.stationIdList = configJson[routerName].stationIdList;
      this.stationIndex = configJson[routerName].stationIndex;
      this.stationVentNameFix = configJson[routerName].stationVentNameFix;
      this.sideName = configJson[routerName].sideName;
      this.stationTypeName = configJson[routerName].stationTypeName;
      this.dataSource = configJson[routerName].dataSource;

      this.outputName1 = configJson[routerName].outputName1;
      this.outputName2 = configJson[routerName].outputName2;
      this.outputName3 = configJson[routerName].outputName3;
      this.outputName4 = configJson[routerName].outputName4;
      this.outputName5 = configJson[routerName].outputName5;
      this.outputName6 = configJson[routerName].outputName6;
    },
    findDeviceId(deviceName) {
      const device = this.deviceList.find((el) => {
        return el.deviceName === deviceName;
      });
      if (!device) {
        console.log(`deviceName${deviceName}###`);
      }
      return device.deviceId || "";
    },
    getStatisticsData(deviceId) {
      return this.$http.get("/statistics/DeviceData?deviceId=" + deviceId + "&interval=BY_HOUR&insertBlankData=true");
    },
    getCurrentData(stationId) {
      return this.$http.get(`/deviceData/Station?stationId=${stationId}`);
    },
    getData() {
      // this.getLineChartData();

      let requestList = [];
      for (let stationId of this.stationIdList) {
        requestList.push(this.getCurrentData(stationId));
      }

      let currentData = {};
      this.$http.all(requestList).then(
        this.$http.spread((...resList) => {
          for (let res of resList) {
            Object.assign(currentData, res.data);
          }

          setTimeout(() => {
            this.loadingData = false;
          }, 500);

          const switchIdTop11T = this.findDeviceId(this.switchTitleTop11 + "温度");
          const switchIdTop11H = this.findDeviceId(this.switchTitleTop11 + "湿度");
          this.switchDataTop11 = [
            {
              data: currentData[switchIdTop11T].value,
              isError: currentData[switchIdTop11T].errorLevel,
              unit: "℃",
            },
            {
              data: currentData[switchIdTop11H].value,
              isError: currentData[switchIdTop11H].errorLevel,
              unit: "%",
            },
          ];

          const switchIdTop21 = this.findDeviceId("上游" + this.switchTitleTop21.replace("启停设定", "启动设定"));
          const switchIdTop21B = this.findDeviceId("上游" + this.switchTitleTop21.replace("启停设定", "停止设定"));
          const switchIdTop22 = this.findDeviceId("上游" + this.switchTitleTop22.replace("启停设定", "启动设定"));
          const switchIdTop22B = this.findDeviceId("上游" + this.switchTitleTop22.replace("启停设定", "停止设定"));
          const switchIdTop23 = this.findDeviceId(this.switchTitleTop23 + "运行");
          const switchIdTop23B = this.findDeviceId(this.switchTitleTop23 + "故障");
          const switchIdTop23C = this.findDeviceId(this.switchTitleTop23 + "报警");
          const switchIdTop24 = this.findDeviceId(this.switchTitleTop24 + "运行小时");
          const switchIdTop25 = this.findDeviceId("上游" + this.switchTitleTop25);
          const switchIdTop26 = this.findDeviceId("上游" + this.switchTitleTop26);
          const switchIdTop27 = this.findDeviceId("上游" + this.switchTitleTop27.replace("过滤器", "处理过滤器堵塞"));
          const switchIdTop27B = this.findDeviceId("上游" + this.switchTitleTop27.replace("过滤器", "再生过滤器堵塞"));
          const switchIdTop28 = this.findDeviceId(this.switchTitleTop28 + "运行");
          this.switchDataTop21 = [
            {
              data: currentData[switchIdTop21].value,
              isError: currentData[switchIdTop21].errorLevel,
              unit: "%",
            },
            {
              data: currentData[switchIdTop21B].value,
              isError: currentData[switchIdTop21B].errorLevel,
              unit: "%",
            },
          ];
          this.switchDataTop22 = [
            {
              data: currentData[switchIdTop22].value,
              isError: currentData[switchIdTop22].errorLevel,
              unit: "%",
            },
            {
              data: currentData[switchIdTop22B].value,
              isError: currentData[switchIdTop22B].errorLevel,
              unit: "%",
            },
          ];
          this.switchDataTop23 = [
            {
              data: currentData[switchIdTop23C].value,
              isError: currentData[switchIdTop23C].errorLevel,
              isZh: true,
              textOn: "警告",
            },
            {
              data: currentData[switchIdTop23B].value,
              isError: currentData[switchIdTop23B].errorLevel,
              isZh: true,
              textOn: "故障",
            },
            {
              data: currentData[switchIdTop23].value,
              isError: currentData[switchIdTop23].errorLevel,
            },
          ];
          this.switchDataTop24 = {
            data: currentData[switchIdTop24].value,
            isError: currentData[switchIdTop24].errorLevel,
            isRunningTime: true,
            isHour: true,
          };
          this.switchDataTop25 = {
            data: currentData[switchIdTop25].value,
            isError: currentData[switchIdTop25].errorLevel,
          };
          this.switchDataTop26 = {
            data: currentData[switchIdTop26].value,
            isError: currentData[switchIdTop26].errorLevel,
          };
          this.switchDataTop27 = [
            {
              data: currentData[switchIdTop27].value,
              isError: currentData[switchIdTop27].errorLevel,
              isZh: true,
              textOn: "处理",
            },
            {
              data: currentData[switchIdTop27B].value,
              isError: currentData[switchIdTop27B].errorLevel,
              isZh: true,
              textOn: "再生",
            },
          ];
          this.switchDataTop28 = {
            data: currentData[switchIdTop28].value,
            isError: currentData[switchIdTop28].errorLevel,
          };

          const switchIdTop31 = this.findDeviceId("下游" + this.switchTitleTop31.replace("启停设定", "启动设定"));
          const switchIdTop31B = this.findDeviceId("下游" + this.switchTitleTop31.replace("启停设定", "停止设定"));
          const switchIdTop32 = this.findDeviceId("下游" + this.switchTitleTop32.replace("启停设定", "启动设定"));
          const switchIdTop32B = this.findDeviceId("下游" + this.switchTitleTop32.replace("启停设定", "停止设定"));
          const switchIdTop33 = this.findDeviceId(this.switchTitleTop33 + "运行");
          const switchIdTop33B = this.findDeviceId(this.switchTitleTop33 + "故障");
          const switchIdTop33C = this.findDeviceId(this.switchTitleTop33 + "报警");
          const switchIdTop34 = this.findDeviceId(this.switchTitleTop34 + "运行小时");
          const switchIdTop35 = this.findDeviceId("下游" + this.switchTitleTop35);
          const switchIdTop36 = this.findDeviceId("下游" + this.switchTitleTop36);
          const switchIdTop37 = this.findDeviceId("下游" + this.switchTitleTop37.replace("过滤器", "处理过滤器堵塞"));
          const switchIdTop37B = this.findDeviceId("下游" + this.switchTitleTop37.replace("过滤器", "再生过滤器堵塞"));
          const switchIdTop38 = this.findDeviceId(this.switchTitleTop38 + "运行");
          this.switchDataTop31 = [
            {
              data: currentData[switchIdTop31].value,
              isError: currentData[switchIdTop31].errorLevel,
              unit: "%",
            },
            {
              data: currentData[switchIdTop31B].value,
              isError: currentData[switchIdTop31B].errorLevel,
              unit: "%",
            },
          ];
          this.switchDataTop32 = [
            {
              data: currentData[switchIdTop32].value,
              isError: currentData[switchIdTop32].errorLevel,
              unit: "%",
            },
            {
              data: currentData[switchIdTop32B].value,
              isError: currentData[switchIdTop32B].errorLevel,
              unit: "%",
            },
          ];
          this.switchDataTop33 = [
            {
              data: currentData[switchIdTop33C].value,
              isError: currentData[switchIdTop33C].errorLevel,
              isZh: true,
              textOn: "警告",
            },
            {
              data: currentData[switchIdTop33B].value,
              isError: currentData[switchIdTop33B].errorLevel,
              isZh: true,
              textOn: "故障",
            },
            {
              data: currentData[switchIdTop33].value,
              isError: currentData[switchIdTop33].errorLevel,
            },
          ];
          this.switchDataTop34 = {
            data: currentData[switchIdTop34].value,
            isError: currentData[switchIdTop34].errorLevel,
            isRunningTime: true,
            isHour: true,
          };
          this.switchDataTop35 = {
            data: currentData[switchIdTop35].value,
            isError: currentData[switchIdTop35].errorLevel,
          };
          this.switchDataTop36 = {
            data: currentData[switchIdTop36].value,
            isError: currentData[switchIdTop36].errorLevel,
          };
          this.switchDataTop37 = [
            {
              data: currentData[switchIdTop37].value,
              isError: currentData[switchIdTop37].errorLevel,
              isZh: true,
              textOn: "处理",
            },
            {
              data: currentData[switchIdTop37B].value,
              isError: currentData[switchIdTop37B].errorLevel,
              isZh: true,
              textOn: "再生",
            },
          ];
          this.switchDataTop38 = {
            data: currentData[switchIdTop38].value,
            isError: currentData[switchIdTop38].errorLevel,
          };

          const switchIdTop41T = this.findDeviceId(this.switchTitleTop41 + "温度");
          const switchIdTop41H = this.findDeviceId(this.switchTitleTop41 + "湿度");
          this.switchDataTop41 = [
            {
              data: currentData[switchIdTop41T].value,
              isError: currentData[switchIdTop41T].errorLevel,
              unit: "℃",
            },
            {
              data: currentData[switchIdTop41H].value,
              isError: currentData[switchIdTop41H].errorLevel,
              unit: "%",
            },
          ];
        })
      );
    },

    revertSwitchValue(input) {
      if (input === 0) {
        return 1;
      } else if (input === 1) {
        return 0;
      } else {
        return input;
      }
    },

    setPieHistogramDataAndError(currentData, echartSeriesDataName, temperatureName, humidityName, warningFlagName) {
      const temperatureId = this.findDeviceId(temperatureName);
      const humidityId = this.findDeviceId(humidityName);
      this[echartSeriesDataName] = {
        data1: currentData[temperatureId].value,
        data2: currentData[humidityId].value,
      };

      let errorLevel = this.getErrorLevelFromMultipleDevice(currentData[temperatureId].errorLevel, this[warningFlagName]);
      errorLevel = this.getErrorLevelFromMultipleDevice(currentData[humidityId].errorLevel, this[warningFlagName]);
      this[warningFlagName] = errorLevel;
    },
    getLineChartData() {
      let temperatureDeviceName = "除湿机温度";
      let humidityDeviceName = "除湿机湿度";
      this.$http
        .all([this.getStatisticsData(this.findDeviceId(temperatureDeviceName)), this.getStatisticsData(this.findDeviceId(humidityDeviceName))])
        .then(
          this.$http.spread((temperaturePromise, humidityPromise) => {
            this.setLineData(temperaturePromise, humidityPromise, "humidityLineData", "warningFlagLeft");
          })
        );
    },
    setLineData(temperatureData, humidityData, echartSeriesDataName, warningFlagName) {
      let data1 = {};
      let data2 = {};
      temperatureData.data.dataList.forEach((item, index) => {
        data1[item.StatisticsDate] = item.value;
      });
      humidityData.data.dataList.forEach((item, index) => {
        data2[item.StatisticsDate] = item.value;
      });

      this[echartSeriesDataName] = {
        data1: data1,
        data2: data2,
      };

      let errorLevel = this.getErrorLevelFromMultipleDevice(temperatureData.data.errorLevel, this[warningFlagName]);
      errorLevel = this.getErrorLevelFromMultipleDevice(humidityData.data.errorLevel, this[warningFlagName]);
      this[warningFlagName] = errorLevel;
    },
    getErrorLevelFromMultipleDevice(newErrorLevel, currentErrorLevel) {
      if (currentErrorLevel === "Error") {
        return "Error";
      } else if (currentErrorLevel === "Warning") {
        if (newErrorLevel === "Error") {
          return "Error";
        } else {
          return "Warning";
        }
      } else {
        return newErrorLevel;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.dehumidifier-room {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: stretch;
  align-content: stretch;
  padding-top: 10px;
  padding-bottom: 10px;

  // & div {
  //   border: 1px solid;
  // }

  .dehumidifier-main {
    width: 100%;
    height: 100%;

    display: flex;
    justify-content: space-between;
    flex-direction: column;
    flex-wrap: wrap;
    align-items: stretch;
    align-content: space-between;
  }

  .column-line {
    width: 100%;
    height: calc(50% - 10px);

    border: 2px solid #dfe4ea;
    border-radius: 10px;
  }

  .column-line-L {
    width: 100%;
    height: calc(55% - 7px);
    min-height: 380px;

    border: 2px solid #dfe4ea;
    border-radius: 10px;
  }

  .column-line-S {
    width: 100%;
    height: calc(45% - 7px);
    min-height: 250px;

    border: 2px solid #dfe4ea;
    border-radius: 10px;
  }

  .column-line-XL {
    width: 100%;
    height: calc(75% - 7px);
    min-height: 430px;

    border: 2px solid #dfe4ea;
    border-radius: 10px;
  }

  .column-line-XS {
    width: 100%;
    height: calc(25% - 7px);
    min-height: 200px;

    border: 2px solid #dfe4ea;
    border-radius: 10px;
  }

  .column-line-full {
    height: 100%;
    min-height: 635px;

    border: 2px solid #dfe4ea;
    border-radius: 10px;
  }

  .main-column {
    width: calc(100% / 4 - 15px);
    height: 100%;
    border-color: yellow;

    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }

  .main-column-small {
    width: calc(100% / 7 - 70px);
    height: 100%;
    border-color: yellow;

    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    border: 2px solid #dfe4ea;
    border-radius: 10px;
  }

  .main-column-large {
    width: calc(100% / 7 + 70px);
    height: 100%;
    border-color: yellow;

    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    border: 2px solid #dfe4ea;
    border-radius: 10px;
  }

  .switch-in-tooltip {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    margin-bottom: 5px;
  }

  .main-column-multi-line {
    width: calc(100% / 4 - 10px);
    height: 100%;
    border-color: yellow;

    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .switch-item-title {
    height: 38px;
    width: calc(100% - 10px);
    box-sizing: border-box;
    margin: 5px 5px 5px 5px;
    flex-shrink: 0;

    &:last-child {
      margin-bottom: 0;
    }

    background-color: rgba(255, 255, 255, 0.6);
  }

  .switch-item-sub-title {
    height: 33px;
    width: calc(100% - 10px);
    box-sizing: border-box;
    margin: 5px 5px 5px 5px;
    flex-shrink: 0;

    &:last-child {
      margin-bottom: 0;
    }

    background-color: rgba(255, 255, 255, 0.6);
  }

  .switch-item {
    height: 33px;
    width: calc(100% - 10px);
    box-sizing: border-box;
    margin: 5px 5px 5px 5px;
    flex-shrink: 0;

    &:last-child {
      margin-bottom: 0;
    }

    background-color: rgba(255, 255, 255, 0.6);
  }

  .tooltip-slot {
    line-height: 1.4;
  }
}
</style>
